import { render, staticRenderFns } from "./SapModular.vue?vue&type=template&id=1e0831c6&scoped=true&"
import script from "./SapModular.vue?vue&type=script&lang=js&"
export * from "./SapModular.vue?vue&type=script&lang=js&"
import style0 from "./SapModular.vue?vue&type=style&index=0&id=1e0831c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0831c6",
  null
  
)

export default component.exports